<script>
export default {
}
</script>
<template>
  <icon-base>
    <g>
      <g id="Canvas_1_Layer_1">
        <g id="bolt">
          <path d="M 10.7 9 L 12.3 0.3 L 7.8 13.1 L 10.1 11.6 L 8.2 20.3 L 12.6 7.8 Z" />
        </g>
        <g id="left">
          <path d="M 3 8.6 L -0.7 8.6 L -0.7 12.8 L 3 12.8 L 3 16.3 L 7.7 10.5 L 3 5.1 Z" />
        </g>
        <g id="right">
          <path d="M 17.6 12.8 L 21.3 12.8 L 21.3 8.6 L 17.6 8.6 L 17.6 5.1 L 12.9 10.8 L 17.6 16.3 Z" />
        </g>
      </g>
    </g>
  </icon-base>
</template>